// frontend/src/components/FeatureGate.jsx
// ============================================================================
// COMPOSANT FEATURE GATE - AFFICHAGE CONDITIONNEL BASÉ SUR FEATURE FLAGS
// ============================================================================

import React from 'react';
import { useFeatureFlag } from '../hooks/useFeatureFlag';

/**
 * Composant pour afficher conditionnellement du contenu selon une feature
 * 
 * Usage :
 * <FeatureGate feature="rfid_attendance">
 *   <ButtonPointageRFID />
 * </FeatureGate>
 * 
 * Avec fallback :
 * <FeatureGate 
 *   feature="rfid_attendance"
 *   fallback={<p>Fonctionnalité non disponible</p>}
 * >
 *   <ButtonPointageRFID />
 * </FeatureGate>
 */
const FeatureGate = ({ 
  feature, 
  children, 
  fallback = null,
  loadingComponent = null,
  showLoading = false
}) => {
  const { isEnabled, loading, error } = useFeatureFlag(feature);

  // Pendant le chargement
  if (loading && showLoading) {
    return loadingComponent || <div>Chargement...</div>;
  }

  // En cas d'erreur, on considère la feature comme désactivée
  if (error) {
    console.warn(`⚠️ [FeatureGate] Erreur pour ${feature}:`, error);
    return fallback;
  }

  // Si feature activée : afficher le contenu
  if (isEnabled) {
    return <>{children}</>;
  }

  // Si feature désactivée : afficher le fallback
  return fallback;
};

export default FeatureGate;